module.exports = __webpack_public_path__ + "media/images/logos/tc-logo-with-bg-be382b9d6590d328f3edfcfd9b5d4b1f.svg";